import React from 'react';
import PropTypes from 'prop-types';
import FormattedListValue from '@/shared/components/FormattedListValue';
import SimplePanel from '@/shared/components/SimplePanel';
import { injectIntl, FormattedMessage, FormattedDate } from 'react-intl';
import messages from '../jobMessages';
import utils from '@/shared/utils/adminpulse';
import FormattedDateShort from '../../../shared/components/FormattedDateShort';

const JobDetailCreateTaskSchedule = ({ job }) => {
  // Some json parameters might still be stored without camelcase in the db, so convert it to camelcase just in case
  const parameters = utils.toCamel(job.parameters);

  return (
    <SimplePanel title={<FormattedListValue list="jobType" id={job.jobType} />}>
      <div className="info-block container-fluid radius4B">
        <div className="row">
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.TaskTemplate} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">
                <FormattedListValue
                  list="tasktemplate"
                  id={parameters.taskTemplateId}
                  fallback=""
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.Schedule} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">
                <FormattedListValue
                  list="taskperiodicity"
                  id={parameters.periodicityId}
                  fallback=""
                />
              </div>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="row">
              <div className="col-md-8 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.StartPlanning} />
                  </b>
                </label>
              </div>
              <div className="col-md-4 col-sm-6">
                <FormattedDateShort value={parameters.planningStart} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-8 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.EndPlanning} />
                  </b>
                </label>
              </div>
              <div className="col-md-4 col-sm-6">
                {parameters.planningStop && <FormattedDateShort value={parameters.planningStop} />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </SimplePanel>
  );
};

JobDetailCreateTaskSchedule.propTypes = {
  job: PropTypes.shape({}).isRequired,
};

export default injectIntl(JobDetailCreateTaskSchedule);
